import type { APIRedirect } from '@/types'

export function isAPIRedirect(obj: unknown): obj is APIRedirect {
    return obj !== null && typeof obj === 'object' && 'redirectTarget' in obj && 'status' in obj
}

export function isCountryRestricted(
    restrictedCountries: string[] | undefined,
    countryCode: string | undefined,
): boolean {
    if (!countryCode || !restrictedCountries?.length) {
        return false
    }
    const upper = countryCode.toUpperCase()
    return restrictedCountries.some((c) => c.toUpperCase() === upper)
}

const min = 60 * 1000
export const DEFAULT_QUERY_CACHE = 10 * min
export const HOMEPAGE_CATEGORIES_CACHE = 5 * min
export const TRENDING_CACHE = 5 * min
